import { fetcher, queryString, useRecoilQuery } from '@shared/hooks/recoil-query';
import { LowerRole } from '@shared/types';

import {
  giftDeliveryCategoryDataAtomFamily,
  giftDeliveryCategoryListDataAtom,
  giftDeliveryCategoryListStatusAtom,
  giftDeliveryCategoryStatusAtomFamily,
} from './giftDeliveryCategory.atom';

const giftDeliveryCategoryListUrl = (role: LowerRole) => {
  return `/${role}/gift-delivery-category?${queryString({
    options: { sort: { order: 1, name: 1 } },
  })}`;
};

export const useGiftDeliveryCategoryListHook = (role: LowerRole, skip = false) => {
  useRecoilQuery(
    giftDeliveryCategoryListStatusAtom,
    giftDeliveryCategoryListDataAtom,
    giftDeliveryCategoryListUrl(role),
    fetcher,
    skip,
  );
};

const giftDeliveryCategoryUrl = (id: string, role: LowerRole) => {
  return `/${role}/gift-delivery-category/${id}`;
};

export const useGiftDeliveryCategoryHook = (
  id: string,
  role: LowerRole,
  skip = false,
) => {
  useRecoilQuery(
    giftDeliveryCategoryStatusAtomFamily(id),
    giftDeliveryCategoryDataAtomFamily(id),
    giftDeliveryCategoryUrl(id, role),
    fetcher,
    skip || !id,
  );
};
